export const IMAGE_PATH = "/images/";
export const Api_Signin = "api/signin";
export const Api_User = "api/user";
export const Api_Signup = "api/signup";
export const Api_Architecture = "api/architecture";
export const Api_Config = "api/config";
export const Api_Region = "api/region";
export const Api_Upload = "api/upload";
export const Api_Apartment = "api/apartment";
export const Api_GetPublished = "getPublished";
export const Api_GetUnPublished = "getUnPublished";
export const Api_GetOwns = "getOwns";
export const Api_Reserve = "api/reserve";
export const Api_Evaluate = "api/evaluate";
export const Api_ConfirmReserve = "api/confirm_reserve";
export const Api_Features = "api/features";
export const Api_CancelReserve = "api/cancel-reserve";
export const Api_CancelConfirmed = "api/cancel_confirmed";
export const Api_Notifications = "api/notifications";
export const Api_SendMessage = "api/send-message";
export const Api_DeviceTokens = "api/device-tokens";
export const Api_Report = "api/reservations-report";
export const Api_Currency = "api/currency";
export const Api_ApartmentManagement = "apartment-management";
